module.exports = __webpack_public_path__ + "static/img/4.82da09c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4.jpg
// module id = CtaL
// module chunks = 1